import { CommonModule } from '@angular/common';
import { Component, Inject, inject, signal, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { APPLICATION_TYPE } from '@core';

import { MessageComponent } from '../message';

export interface ConfirmationDialogProps {
  cancelBtnText?: string;
  confirmBtnText?: string;
  description?: string;
  isDeleteTypePopup?: boolean;
  showWarning?: boolean;
  template?: TemplateRef<any>;
  templateContext?: any;
  title: string;
  warningText?: string;
}

@Component({
  imports: [MatDialogModule, CommonModule, MessageComponent],
  selector: 'avs-li-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
})
export class ConfirmationDialogComponent {
  static open(dialog: MatDialog, data: ConfirmationDialogProps) {
    const config = new MatDialogConfig();

    config.disableClose = true;
    config.backdropClass = 'backdrop-modal-panel';
    config.data = {
      ...data,
    };
    const dialogRef = dialog.open(ConfirmationDialogComponent, config);

    return dialogRef.afterClosed();
  }

  protected isMobile = signal(false);

  private appType = inject(APPLICATION_TYPE);

  constructor(
    @Inject(MAT_DIALOG_DATA) protected data: ConfirmationDialogProps,
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
  ) {
    this.isMobile.set(this.appType === 'mobile');
  }
}
